import { FC } from 'react';
import { Card, Title, NumberInput, Textarea } from '@mantine/core';
import { DateInput } from '@mantine/dates';
import { FormDetails } from './ProductTypeForm';
import { ProductType } from '@/remoteApi/ProductTypeApi';

interface Props {
	productType: ProductType;
	formDetails: FormDetails;
	hanleDetailsChange: (
		key: keyof FormDetails,
		value: FormDetails[keyof FormDetails]
	) => void;
	questionGroupsCount: number;
}

export const OrderDetails: FC<Props> = ({
	productType,
	formDetails,
	hanleDetailsChange,
	questionGroupsCount,
}) => {
	const today = new Date();
	const maxDate = new Date();
	maxDate.setDate(today.getDate() + 18);

	return (
		<Card>
			<Title order={3} c="black" mb="md">
				{`Krok ${questionGroupsCount}/${questionGroupsCount} - Dane końcowe`}
			</Title>
			{!productType.isPerDimensionQuantityEnabled && (
				<NumberInput
					mb="md"
					label="Liczba produktów"
					defaultValue={50}
					min={1}
					max={10_000}
					step={1}
					suffix=" szt."
					value={formDetails.quantity}
					onChange={(val) => {
						hanleDetailsChange('quantity', val);
					}}
				/>
			)}
			<DateInput
				mb="md"
				label="Termin zamówienia"
				placeholder="Wybierz termin zamówienia"
				value={formDetails.orderDate}
				onChange={(val) => {
					hanleDetailsChange('orderDate', val);
				}}
				minDate={maxDate}
			/>
			<Textarea
				label="Uwagi do zamówienia"
				placeholder="Wpisz uwagi do zamówienia"
				autosize
				minRows={4}
				value={formDetails.note}
				onChange={({ target }) => {
					hanleDetailsChange('note', target.value);
				}}
			/>
		</Card>
	);
};
